import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getCostPerOunceShipped = {
  name: "getCostPerOunceShipped" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
